<script>
	import { sizeSelect } from "../../store/store";

	const defaultOptions = [
		{
			label: "Show 20",
			value: "20",
		},
		{
			label: "Show 40",
			value: "40",
		},
		{
			label: "Show 60",
			value: "60",
		},
	];

	let size = 20;

	function handleChange(e) {
		sizeSelect.set(e.target.value);
	}

	sizeSelect.subscribe((value) => {
		size = value;
	});
</script>

<select
	name="size"
	id="size"
	class="form-select getgo select ms-auto"
	on:change={(e) => handleChange(e)}
	value={$sizeSelect}
>
	{#each defaultOptions as option}
		<option value={option.value}>{option.label}</option>
	{/each}
</select>

<style>
	#size {
		width: 150px;
	}
	.form-select getgo select {
		max-width: 120px;
	}
</style>
